import React from "react";
import FormInput from "../../Inputs/FormInput";
import styles from "./DocumentConsumptionGrid.module.css";

const toNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const DocumentConsumptionGrid = ({
  rows = [],
  readOnly = false,
  errors = {},
  onChangeQuantity,
  onChangeRate,
}) => {
  return (
    <div className={styles.gridWrap}>
      <table className={styles.gridTable}>
        <thead>
          <tr>
            <th>Product Name</th>
            <th>Quoted Quantity</th>
            <th>Already Ordered</th>
            <th>Remaining Quantity</th>
            <th>Order Now Quantity</th>
            <th>Rate</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          {rows.length ? (
            rows.map((row) => {
              const rowIndex = Number(row.row_index || 0);
              const remainingQty = toNumber(row.remaining_quantity);
              const disabledRow = remainingQty <= 0;
              return (
                <tr key={`doc-consume-${row.quotation_item_fid}-${rowIndex}`}>
                  <td>{row.product_name || "-"}</td>
                  <td>{row.quoted_quantity || 0}</td>
                  <td>{row.consumed_quantity || 0}</td>
                  <td>
                    {disabledRow ? (
                      <span className={styles.fullyOrderedBadge}>Fully Ordered</span>
                    ) : (
                      row.remaining_quantity || 0
                    )}
                  </td>
                  <td className={styles.inputCell}>
                    <FormInput
                      type="number"
                      decimalPlaces={2}
                      value={row.quantity || ""}
                      disabled={readOnly || disabledRow}
                      error={errors[`po_items_${rowIndex}_quantity`]}
                      onChange={(e) => onChangeQuantity?.(rowIndex, e.target.value)}
                    />
                  </td>
                  <td className={styles.inputCell}>
                    <FormInput
                      type="number"
                      decimalPlaces={2}
                      value={row.rate || ""}
                      disabled={readOnly || disabledRow}
                      error={errors[`po_items_${rowIndex}_rate`]}
                      onChange={(e) => onChangeRate?.(rowIndex, e.target.value)}
                    />
                  </td>
                  <td>{row.amount || 0}</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={7} className={styles.emptyCell}>
                No products found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DocumentConsumptionGrid;
